import { Button } from '../ds/index.js'

const sectionLabel = { color: 'var(--color-gold)' }

// "On startup" preference — writes startupBehavior to the profile.
export default function StartupSection({ user, updateProfile }) {
  const value = user.startupBehavior === 'home' ? 'home' : 'continue'
  const set = (v) => { if (v !== value) updateProfile({ startupBehavior: v }) }
  const row = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: '10px 0', borderTop: '1px solid var(--color-divider-dark)' }
  return (
    <>
      <div className="eyebrow" style={{ margin: '16px 0 10px' }}><span className="tag-label" style={sectionLabel}>Startup</span></div>
      <div style={row}>
        <span style={{ fontSize: 13, color: 'var(--color-white)' }}>On startup</span>
        <div style={{ display: 'flex', gap: 8 }}>
          <Button variant={value === 'continue' ? 'gold' : 'ghost'} size="sm" onClick={() => set('continue')}>Continue where you left off</Button>
          <Button variant={value === 'home' ? 'gold' : 'ghost'} size="sm" onClick={() => set('home')}>Open Home</Button>
        </div>
      </div>
    </>
  )
}
